import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SERVER_API_URL } from '../../app/config';

@Injectable()
export class OPCProvider {
  constructor(public httpClient: HttpClient) {}

  getFirstLoad(engine) {
    return this.httpClient.get(`${SERVER_API_URL}/opc/${engine}`);
  }

  getLoadHistory1524(engine) {
    return this.httpClient.get(`${SERVER_API_URL}/opc-load/history15/${engine}`);
  }

  getLastLoad(engine) {
    return this.httpClient.get(`${SERVER_API_URL}/opc-last-load/${engine}`);
  }
}



// WEBPACK FOOTER //
// ./src/providers/opc/opc.ts